import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import { Button, Intent } from '@blueprintjs/core';
import * as DataList from 'components/DataList';
import Toast from 'helpers/toaster';
import SettingsPage from 'components/SettingsPage';
import DefaultLineItemsList, {
  LINE_ITEM_COLUMNS, LINE_ITEM_CARDS, LINE_ITEM_MIN_TABLE_WIDTH,
} from 'components/Preference/DefaultLineItems';

// Settings > Default line items (/preferences/default_line_items).
@inject('preferenceStore') @observer
class DefaultLineItems extends Component {

  componentDidMount() {
    this.props.preferenceStore.loadPreferences();
  }

  add = () => {
    this.props.preferenceStore.addDefaultBlankLineItem()
      .then(() => {
        Toast.show({ message: 'Line item added. Fill it in, then save it.', intent: Intent.SUCCESS });
      })
      .catch((error) => {
        const reason = error && error.response && error.response.data && error.response.data.errors;
        Toast.show({ message: reason || "Couldn't add a line item. Try again.", intent: Intent.DANGER });
      });
  };

  render() {
    const { preferenceStore } = this.props;
    const { isLoading, isError, object } = preferenceStore.preference;
    const items = object && object.attributes ? object.attributes.default_line_items : null;
    let content = null;
    if (object && object.attributes) {
      content = <DefaultLineItemsList items={items} onAdd={this.add} />;
    } else if (isError && !isLoading) {
      content = <DataList.LoadError noFilters noun="default line items" onRetry={() => preferenceStore.loadPreferences()} />;
    } else if (isLoading) {
      content = (
        <DataList.Loading
          columns={LINE_ITEM_COLUMNS}
          cards={LINE_ITEM_CARDS}
          minTableWidth={LINE_ITEM_MIN_TABLE_WIDTH}
          noun="default line items"
          rows={3}
        />
      );
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Default line items | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Default line items"
          description="Charges such as a percentage of materials or labor, or a set dollar amount."
          actions={(
            <Button
              className="sp-button sp-button--primary"
              icon="add"
              text="Add line item"
              loading={preferenceStore.showLoader}
              onClick={this.add}
            />
          )}
        >
          {content}
        </SettingsPage>
      </React.Fragment>
    );
  }
}

export default DefaultLineItems;
